<template>
  <div>
    <span class="icons">
      <b-icon-eye></b-icon-eye>
    </span>
    <span v-for="option in options" :key="option" class="option" :class="[{ active: follow === option }, `option--${option}`]" @click.stop.prevent="update(option)">{{ option === 'default' ? 'On' : 'Off'}}</span>
  </div>
</template>

<script>
  export default {
    props: ['follow'],

    data() {
      return {
        options: ['default', 'disabled']
      }
    },

    methods: {
      update(option) {
        this.$emit('update:follow', option);
      }
    }
  }
</script>

<style scoped>
  svg {
    margin-right: 0.5em;
  }

  .option {
    position: relative;
    display: inline-block;
    color: #aaa;

    margin-right: 0.5em;
  }

  .option.active {
    font-weight: bold;
    color: #000;
  }
</style>